<template>
  <div class="modal fade" role="dialog" style="margin-top: 60%">
    <div class="modal-dialog modal-lg" style="width: 850px">
      <div class="modal-content" style="width: 850px">
        <div class="card-box">
          <div style="flex: 1; font-size: 45px; display: flex; justify-content: center; align-items: center;">
            <p style="text-align: center; padding: 0 80px;">前往必孚App查看原文及更多行业资讯，体验更佳。</p>
          </div>
          <div style="height: 150px; border-top: #e0e0e0 solid 1px; display: flex;">
            <div style="width: 50%; height: 150px; text-align: center; line-height: 150px; font-size: 50px; color: #b0b1b0;" @click="handleClose">取消</div>
            <div style="height: 150px; width: 1px; background: #e0e0e0;"/>
            <div style="width: 50%; height: 150px; text-align: center; line-height: 150px; font-size: 50px; color: #59a8fe;" @click="handleContinue">前往</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  methods: {
    handleContinue() {
      $('#shareTipModal').modal('hide')
      setTimeout(() => {
        this.$emit('continue')
      }, 200)
    },
    handleClose() {
      $('#shareTipModal').modal('hide')
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.card-box {
  min-height: 400px;
  max-width: 850px;
  display: flex;
  flex-direction: column;
  border-radius: 20px!important;
}
.modal-content {
  border-radius: 20px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/sharepage/tip-dialog.vue